const WHOLE_NUMBER = /^\d+$/;
export const isValidDraft = (editor, draft)=>editor !== 'integer' || draft === '' || WHOLE_NUMBER.test(draft);
